export const formatDates = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  export const formatDate = (date: string) => {
    const newDate = new Date(date);
    const month = newDate.getMonth() + 1;
    const day = newDate.getDate();
    const year = newDate.getFullYear();
    //  const hour = newDate.getHours();
    // const minute = newDate.getMinutes();
    // const second = newDate.getSeconds();
    const newFormatDate = `${day}/${month}/${year} `;
    
    return newFormatDate;
};

export const formatDateTime = (date: string) => {
  const newDate = new Date(date);
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  const hour = newDate.getHours();
  const minute = newDate.getMinutes();

  const newFormatDate = `${day}/${month}/${year} ${hour}:00`;

  return newFormatDate;
};

export const formatDateWithTime = (date: string) => {
  const newDate = new Date(date);
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  const hour = newDate.getHours().toString().padStart(2, '0');
  const minute = newDate.getMinutes().toString().padStart(2, '0');
  const second = newDate.getSeconds().toString().padStart(2, '0');
  
  const newFormatDate = `${day}/${month}/${year} ${hour}:${minute}`;
  
  return newFormatDate;
};